"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceOverallStatus = void 0;
var DeviceOverallStatus;
(function (DeviceOverallStatus) {
    DeviceOverallStatus["CONFIGURING"] = "configuring";
    DeviceOverallStatus["IDLE"] = "idle";
    DeviceOverallStatus["OFFLINE"] = "offline";
    DeviceOverallStatus["INACTIVE"] = "inactive";
    DeviceOverallStatus["POST_PROVISIONING"] = "post-provisioning";
    DeviceOverallStatus["UPDATING"] = "updating";
    DeviceOverallStatus["ORDERED"] = "ordered";
    DeviceOverallStatus["PREPARING"] = "preparing";
    DeviceOverallStatus["SHIPPED"] = "shipped";
})(DeviceOverallStatus = exports.DeviceOverallStatus || (exports.DeviceOverallStatus = {}));
